var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('Modal',{attrs:{"config":_vm.modalConfig},on:{"save":_vm.logout}},[_c('span',{staticClass:"modal-content section-helpers",attrs:{"slot":"modalContent"},slot:"modalContent"},[_vm._v(" "+_vm._s(_vm.$t('common.idleTimeoutContent'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }